/**
 * Analytics Provider
 * Initializes all tracking hooks for the application
 */

import { ReactNode } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';

interface AnalyticsProviderProps {
  children: ReactNode;
}

function AnalyticsTracker(): null {
  useAnalytics();
  return null;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps): JSX.Element {
  return (
    <>
      <AnalyticsTracker />
      {children}
    </>
  );
}
